// "Mission Memory: The AI That Remembers What It Made" — how a completed mission's
// output auto-saves into EAKC's searchable knowledge base, the manual-vs-auto
// correction, and the transient-outage debugging story that proved it works.
// Cold Compute / Neon kit. ~134s @ 30fps. Grounded in EAKC-MVP commits 30b48d60 +
// f99b2a79 and the 2026-07-09 live re-ingest verification (4 sources, 7 chunks embedded).
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames (30fps); contiguous.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //          0:00-0:05  the AI did the work, then forgot it
  problem: { start: 150, duration: 570 }, //     0:05-0:24  output trapped in blackboard + email
  feature: { start: 720, duration: 540 }, //     0:24-0:42  auto-capture into the searchable library
  correction: { start: 1260, duration: 480 }, // 0:42-0:58  the Save button was the wrong idea
  bug1: { start: 1740, duration: 450 }, //       0:58-1:13  the test failed: empty shells
  bug2: { start: 2190, duration: 540 }, //       1:13-1:31  three red herrings, then the real cause
  fix: { start: 2730, duration: 480 }, //        1:31-1:47  reproduced live, all four filled
  learnings: { start: 3210, duration: 480 }, //  1:47-2:03  two lessons that stuck
  outro: { start: 3690, duration: 330 }, //      2:03-2:14  the tool stops, the system compounds
} as const;

export const TOTAL_DURATION = 4020; // 134s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
